(function () {
  const STORAGE_KEY = 'partner-access-granted';

  let overlay, modal, closeBtn, submitBtn, requestBtn, passwordInput, errorMsg;
  let pendingUrl = null;

  function getConfig() {
    return window.partnerAccessConfig || {};
  }

  function hasAccess() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function grantAccess() {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      // ignore
    }
  }

    function unlockSectionsIfNeeded() {
    if (!hasAccess()) return;

    document
      .querySelectorAll('.partner-section--locked')
      .forEach(function (wrapper) {
        wrapper.classList.remove('partner-section--locked');
        var overlay = wrapper.querySelector('.partner-section-overlay');
        if (overlay) {
          overlay.remove();
        }
      });
  }


  function openModal(url) {
    pendingUrl = url || null;
    if (!overlay) return;
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    if (passwordInput) {
      passwordInput.value = '';
      passwordInput.focus();
    }
    if (errorMsg) {
      errorMsg.style.display = 'none';
    }
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
  }

  function handlePasswordSubmit() {
    const config = getConfig();
    const correctPassword = (config.password || '').trim();
    const entered = (passwordInput?.value || '').trim();

    if (!entered || !correctPassword) {
      if (errorMsg) {
        errorMsg.textContent = 'Password is not set or is empty.';
        errorMsg.style.display = 'block';
      }
      return;
    }

   if (entered === correctPassword) {
      grantAccess();
      unlockSectionsIfNeeded();
      if (errorMsg) errorMsg.style.display = 'none';
      closeModal();

      if (pendingUrl) {
        window.location.href = pendingUrl;
      }
    } else {
      if (errorMsg) {
        errorMsg.textContent = 'Incorrect password. Please try again.';
        errorMsg.style.display = 'block';
      }
    }
  }

  function handleRequestClick() {
    const config = getConfig();
    const url = config.contactUrl || '/pages/contact';
    window.location.href = url;
  }

  function initElements() {
    overlay = document.getElementById('partner-access-overlay');
    if (!overlay) return;

    modal = overlay.querySelector('.partner-access-modal');
    closeBtn = overlay.querySelector('.partner-access-close');
    submitBtn = document.getElementById('partner-access-submit');
    requestBtn = document.getElementById('partner-access-request');
    passwordInput = document.getElementById('partner-access-password');
    errorMsg = document.getElementById('partner-access-error');

    // Close actions
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    // Submit password
    if (submitBtn) {
      submitBtn.addEventListener('click', handlePasswordSubmit);
    }

    if (passwordInput) {
      passwordInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handlePasswordSubmit();
        }
      });
    }

    // Request access
    if (requestBtn) {
      requestBtn.addEventListener('click', handleRequestClick);
    }
  }

  function initTriggers() {
    const triggers = document.querySelectorAll('[data-partner-access="trigger"]');

    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        if (hasAccess()) {
          // Already has access, let the click behave normally
          return;
        }

        const href = trigger.getAttribute('href') || null;

        e.preventDefault();
        openModal(href);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initElements();
    initTriggers();
    unlockSectionsIfNeeded();
  });

})();
